<h1 id="title" class="title">{{ 'AUTHENTICATION.TITLE' | translate | uppercase }}</h1>
<p class="sub-title">{{ 'AUTHENTICATION.LOGIN_WITH_DECATHLON' | translate }}</p>

<nb-alert *ngIf="errors?.length && !submitted" outline="danger" role="alert">
	<p class="alert-title"><b>{{ 'OHSNAP' | translate }}</b></p>
	<ul class="alert-message-list">
		<li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
	</ul>
</nb-alert>

<form (ngSubmit)="loginAsExtern()" #form="ngForm" aria-labelledby="title">
	<mat-form-field floatLabel="always">
		<input matInput
					 type="email"
					 name="email"
					 id="input-email"
					 placeholder="{{ 'AUTHENTICATION.EMAIL' | translate | uppercase }}"
					 autofocus
					 [(ngModel)]="credentials.email">
	</mat-form-field>
	<mat-form-field floatLabel="always" *ngIf="credentials?.email?.length > 0">
		<input matInput
					 name="password"
					 type="password"
					 id="input-password"
					 placeholder="{{ 'AUTHENTICATION.PASSWORD' | translate | uppercase }}"
					 autofocus
					 [(ngModel)]="credentials.password">
	</mat-form-field>

	<button mat-flat-button color="primary" [disabled]="submitted || !form.valid" (click)="loginAsExtern()">
		{{ 'AUTHENTICATION.LOGIN' | translate | uppercase }}
	</button>
</form>

<section class="another-action" aria-label="Register">
	{{ 'AUTHENTICATION.DONT_HAVE_ACCOUNT' | translate }}
	<a class="text-link"
		 target="_blank"
		 rel="noopener noreferrer"
		 routerLink="/auth/external-registration">{{ 'AUTHENTICATION.REGISTER' | translate }}</a>
</section>

<section class="another-action" aria-label="Register" *ngIf="credentials?.email?.length > 0">
	{{ 'AUTHENTICATION.RESETPASSWORD.TEXT' | translate }}
	<a class="text-link"
		 target="_blank"
		 rel="noopener noreferrer"
		 [href]="resetPasswordUrl">{{ 'AUTHENTICATION.RESETPASSWORD.BUTTON' | translate }}</a>
</section>

<section class="links">
	<button mat-flat-button color="primary" (click)="loginAsIntern()">
		{{ 'AUTHENTICATION.SIGNIN_DECATHLON' | translate | uppercase }}
	</button>
</section>
